export default "__VITE_ASSET__djYX6kDm__"